import React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png"

const Consortium: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on:false,index:0});
    const [en, setEn] = useState(false);
    const contentsEn = [
        "Eesti Maaulikool (EMU), Kreutzwaldi 1, Tartu 51014, Estonia - Coordinator",
        "Universita Degli Studi Di Catania (UNICT), Piazza Universita 2, Catania 95131, Italy",
        "Education and Youth Board (HARNO), Lõõtsa 4, Tallinn 11415, Estonia",
        "Systems Innovation Center Kft. (CSI), Gyakorlo utca 18. fszt. 3., Budapest 1106, Hungary",
        "Taras Shevchenko National University of Kyiv (TSNUK), Volodymyrska St 60, Kyiv 01033, Ukraine",
        "V. N. Karazin Kharkiv National University (KKNU Svobody sq. 4, Kharkiv 61077, Ukraine",
        "Non Government Organization Ukrainian Joint Meteorological and Hydrological Society (UMHS), 15 Lvivska Street, Building 1, room 307, Odesa 65016, Ukraine",
        "National University of Mongolia (NUM), Sukhbaatar District 8th Khoroo Jkh Surguulin Gudam Main Building, Ulaanbaatar 14201, Mongolia",
        "School of Agroecology and Business Institute of Plant and Agricultural Sciences Mongolian University of Life Sciences (SAEB), University Street 103, Darkhan 45047, Mongolia",
        "National Agency for Higher Education Quality Assurance (NAQA), 1 Borysa Hrinchenka Street, Kyiv 01001, Ukraine",
        "Mongolian National Council for Education Accreditation (MNCEA), 401 Teachers Development Palace Peace Avenue 10, Ulaanbaatar 976, Mongolia",
        "Environmental Auditing Association of Mongolia (EAAM) Sukhbaatar District, 8th Khoroo, Ikh Surguuli, Ulaanbaatar 14201, Mongolia.",
    ];

    return (
        <div className={"consortium"}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>

            <h1 style={{lineHeight:"2em",textAlign:"left",padding:"0 90px"}}>
                {en ? "Participants" : "Консорціум" }
            </h1>

            <ol style={{padding:"20px 90px"}} >
                {contentsEn.map((content, index) => (
                    <li key={index} className={"li"}
                        style={{lineHeight:"2em",textAlign:"left"}}
                    >{content}</li>
                ))}
            </ol>

        </div>
    )
}
export default Consortium;